<div class="marketing-panel">
  <div class="marketing-gradient"></div>
  <div class="marketing-decoration marketing-decoration--1"></div>
  <div class="marketing-decoration marketing-decoration--2"></div>
  <div class="marketing-decoration marketing-decoration--3"></div>

  <app-login-network-visualization></app-login-network-visualization>

  <div class="marketing-content">
    <div class="marketing-pill">
      <span class="marketing-pill-icon" aria-hidden="true">❄</span>
      {{ 'Loginpage.marketing_badge' | translate }}
    </div>

    <h2 class="marketing-headline">
      {{ 'Loginpage.marketing_headline_1' | translate }}<br />
      <span class="marketing-headline-accent">{{ 'Loginpage.marketing_headline_2' | translate }}</span>
    </h2>

    <p class="marketing-sub">{{ 'Loginpage.marketing_sub' | translate }}</p>

    <div class="marketing-stats">
      <div class="stat-card">
        <div class="stat-card-value">
          {{ 'Loginpage.stat_1_value' | translate }}<span class="stat-card-unit">{{ 'Loginpage.stat_1_unit' | translate }}</span>
        </div>
        <div class="stat-card-desc">{{ 'Loginpage.stat_1_desc' | translate }}</div>
      </div>
      <div class="stat-card">
        <div class="stat-card-value">
          {{ 'Loginpage.stat_2_value' | translate }}<span class="stat-card-unit">{{ 'Loginpage.stat_2_unit' | translate }}</span>
        </div>
        <div class="stat-card-desc">{{ 'Loginpage.stat_2_desc' | translate }}</div>
      </div>
      <div class="stat-card">
        <div class="stat-card-value">
          {{ 'Loginpage.stat_3_value' | translate }}<span class="stat-card-unit">{{ 'Loginpage.stat_3_unit' | translate }}</span>
        </div>
        <div class="stat-card-desc">{{ 'Loginpage.stat_3_desc' | translate }}</div>
      </div>
    </div>

    <p class="marketing-footnote">{{ 'Loginpage.marketing_footnote' | translate }}</p>
  </div>
</div>
